<div class="fx-fill-height fx-layout-column fx-content-center fx-items-center" id="login">
    <div class="login-card flex flex-row justify-center items-center gap-12">
        <div class="logo-container flex flex-col justify-center items-end">
            <img alt="FireRIS" src="../../assets/images/{{ logo }}" />
            <span class="relative -top-1.5 text-sm font-medium">v2.4.2</span>
        </div>

        <div class="flex flex-col items-start">
            <form [formGroup]="form" class="log-form fx-layout-column fx-content-center fx-items-center">
                <!--username field-->
                <mat-form-field [style.width.px]="320">
                    <mat-label>{{ 'USERNAME' | translate }}</mat-label>
                    <input
                        [placeholder]="'USERNAME' | translate"
                        formControlName="username"
                        matInput
                        [required]="true" />
                    <mat-icon fontIcon="mdi-account-outline" fontSet="mdi" matIconPrefix></mat-icon>
                </mat-form-field>

                <!--password field-->
                <mat-form-field [style.width.px]="320">
                    <mat-label>{{ 'PASSWORD' | translate }}</mat-label>
                    <input
                        [placeholder]="'PASSWORD' | translate"
                        [type]="hide ? 'password' : 'text'"
                        formControlName="password"
                        matInput
                        [required]="true" />
                    <mat-icon
                        (click)="hide = !hide"
                        [fontIcon]="hide ? 'mdi-eye-off' : 'mdi-eye'"
                        fontSet="mdi"
                        matIconSuffix></mat-icon>
                    <mat-icon fontIcon="mdi-lock-outline" fontSet="mdi" matIconPrefix></mat-icon>
                </mat-form-field>

                <mat-form-field [style.width.px]="320">
                    <mat-label>{{ 'IMAGING_CENTER' | translate }}</mat-label>
                    <mat-select
                        [(ngModel)]="selectedCenter"
                        [ngModelOptions]="{ standalone: true }"
                        [placeholder]="'IMAGING_CENTER' | translate">
                        @for (center of centers; track $index) {
                            <mat-option [value]="center"> {{ center.name }}</mat-option>
                        }
                    </mat-select>
                    <mat-icon fontIcon="mdi-map-marker-outline" fontSet="mdi" matIconPrefix></mat-icon>
                </mat-form-field>
            </form>
            @if (errorMsg) {
                <span class="error">{{ errorMsg }}</span>
            }
            <button (click)="onSubmit()" [disabled]="form.invalid" color="primary" mat-raised-button>
                {{ 'LOGIN' | translate }}
            </button>
        </div>
    </div>

    <img
        [height]="48"
        style="position: fixed; bottom: 24px"
        [src]="'assets/images/firethunder.png'"
        alt="FireThunder SARL" />
</div>
